import api from './apiService';

/**
 * Carrega perfil do usuário logado
 * 
 * @returns 
 */
export const getUserProfile = async () => {

    try {
        const response = await api.get('/user');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

/**
 * Carrega usuários ativos na conta
 * 
 * @returns 
 */
export const getAllUsers = async () => {
    try {
        const response = await api.get('/users');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const storeUser = async (data) => {
    try {
        const response = await api.post('/users', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const updateUser = async (data) => {
    try {
        const response = await api.put('/users', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const deleteUser = async (id) => {
    try {
        const response = await api.delete(`/users/${id}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

/**
 * Carrega usuários ativos na conta
 * 
 * @returns 
 */
export const getUsersActives = async () => {
    try {
        const response = await api.get('users/active');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const getCategories = async () => {
    try {
        const response = await api.get('/users/categories');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const storeCategory = async (data) => {
    try {
        const response = await api.post('/users/categories', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const updateCategory = async (data) => {
    try {
        const response = await api.put('/users/categories', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const deleteCategory = async (id) => {
    try {
        const response = await api.delete(`/users/categories/${id}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

